export const createMyTimeRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
